<template>
   <div>
        <img src="http://yd.top917.cn/date/images/user_01.jpg" />
        <img src="http://yd.top917.cn/date/images/user_02.jpg" />
        <img src="http://yd.top917.cn/date/images/user_03.jpg" />
        <img src="http://yd.top917.cn/date/images/user_04.jpg" />
        <a href="/date/quanyi.html"><img src="/date/images/user_05.jpg"></a>
        <img src="http://yd.top917.cn/date/images/user_06.jpg" />

        

    </div>
</template>
<script>
import Recommend from "@components/Recommend";
import { getActivityStatus, getBalance } from "../../api/user";
import "@assets/css2/style.css";
export default {
  name: "UserAccount",
  components: {
    Recommend
  },
  props: {},
  data: function() {
    return {
      now_money: 0,
      orderStatusSum: 0,
      recharge: 0,
      activity: {
        is_bargin: false,
        is_pink: false,
        is_seckill: false
      }
    };
  },
  mounted: function() {
    this.getIndex();
    this.getActivity();
  },
  methods: {
    getIndex: function() {
      let that = this;
      getBalance().then(
        res => {
          that.now_money = res.data.now_money;
          that.orderStatusSum = res.data.orderStatusSum;
          that.recharge = res.data.recharge;
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    },
    getActivity: function() {
      let that = this;
      getActivityStatus().then(
        res => {
          that.activity.is_bargin = res.data.is_bargin;
          that.activity.is_pink = res.data.is_pink;
          that.activity.is_seckill = res.data.is_seckill;
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
